import axios from '../axios';

export interface PriceResponse {
  price: number;
}

export const ethPrice = (): Promise<PriceResponse> => {
  return axios.get('price');
};
